import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

function loadTranslations() {
    let out = {};
    let iso = [];
    var context = require.context("@/locales/", true, /\.json$/);

    context.keys().forEach(function (key) {
        let path = key;
        let tb1 = path.split('./');
        let name = tb1[1];
        let tb2 = name.split('.json');
        let l = tb2[0];
        iso.push(l);
    });

    for (let i = 0; i < iso.length; i++) {
        out[iso[i]] = require('@/locales/' + iso[i] + '.json');
    }

    return out;
}

const locale = 'fr';
const messages = loadTranslations();
const i18n = new VueI18n({
    locale,
    messages,
})

export default i18n